/* eslint-disable react/prop-types */
import React from 'react';

const MegaMenuMobileLinkBlockHeader = ({ linkBlock, onClick }) => {
  const title = linkBlock.title?.value || linkBlock.name;

  const handleClick = e => {
    e.preventDefault();
    onClick?.(e);
  };

  const icon = linkBlock.icon?.value?.url ? (
    <img src={linkBlock.icon.value.url} width={15} height={15} />
  ) : (
    <svg role="presentation" width={15} height={15} fill="#ffffff">
      <use xlinkHref="#chevron-right" />
    </svg>
  );

  return (
    <button
      className="mega-menu-mobile__link-block-header"
      onClick={e => handleClick(e)}
    >
      {title}
      {icon}
    </button>
  );
};

export default MegaMenuMobileLinkBlockHeader;
